import { logger } from '@services/logger/logger.service';
import { QueryClient } from '@tanstack/react-query';
import {
  invalidateSendingRequestsV2Queries,
  SendingRequestsV2Scope,
} from './sendingRequestsV2Cache.util';

const DEBOUNCE_DELAY = 30000; // 30 seconds

let debounceTimeout: NodeJS.Timeout | undefined;
// A pusher burst (multi-document import) can touch several identities at once, so one merged
// scope wouldn't be enough — every distinct scope seen during the window is kept and invalidated
// on flush.
const pendingScopes = new Set<SendingRequestsV2Scope>();

export const invalidateSendingRequestsV2Count = (
  queryClient: QueryClient,
  scope: SendingRequestsV2Scope,
) => {
  pendingScopes.add(scope);

  // Clear previous timeout if exists
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
    logger.info('LOGIC', '[SendingRequestsV2Count] Debounce reset - new event received');
  }

  // Set new timeout - invalidate after debounce delay
  debounceTimeout = setTimeout(() => {
    logger.info('LOGIC', '[SendingRequestsV2Count] Invalidating cache after debounce');
    const scopes = [...pendingScopes];
    pendingScopes.clear();

    for (const pendingScope of scopes) {
      // Restricted to 'count': the list keeps its own immediate, non-debounced invalidation
      // elsewhere. 'all' scopes have no keyScopes field and already cover count on their own.
      invalidateSendingRequestsV2Queries(
        queryClient,
        'all' in pendingScope ? pendingScope : { ...pendingScope, keyScopes: ['count'] },
      );
    }
  }, DEBOUNCE_DELAY);
};
